import { NotificationRepository } from '../repositories/NotificationRepository';
import { logger } from '@/src/core/utils';

export class RegisterPushTokenUseCase {
  constructor(private notificationRepository: NotificationRepository) {}

  async execute(userId: string, token: string, deviceName?: string): Promise<void> {
    logger.debug('RegisterPushToken', 'Registering token for user', { userId });
    await this.notificationRepository.registerPushToken(userId, token, deviceName);
    logger.debug('RegisterPushToken', 'Token registered successfully');
  }
}
